import { useTranslation } from 'react-i18next'

// local imports
import avatar from 'assets/images/avatar.png'
import { IFilteredGymGroupList } from 'types/GymType'
// import GymService from 'service/GymService'
// import FavoriteIconButton from 'components/ui/FavoriteIconButton'
import {
  ReservationButton,
  GymSalonName,
  SalonLocation,
  WorkingHours,
  StyledCard,
  CardHeaderOverlay,
  SalonCapacity,
  GroupTrainerArea,
  LessonDate,
  TrainerInfo,
  FavoriteContainer,
} from '../styled'

interface ComponentProps {
  lesson: IFilteredGymGroupList
  openModal: (lesson: IFilteredGymGroupList) => void
}

export default function GymGroupCard({ lesson, openModal }: ComponentProps) {
  const { t } = useTranslation()
  /* ######### Gym Group Lesson Data Destructuring ######### */
  const {
    // id,
    capacity,
    reservationCount,
    priceStr,
    price,
    reservationAndCapacityStr,
    lessonDateStr,
    startHourStr,
    endHourStr,
    // isFavorite,
    gymLessonType: { name },
    gymTrainer: { fullName, photo, email },
    floor: { name: floorName, locationName: locName, districtName, cityName, countryName, blockName },
  } = lesson || {}


  /* Location String */
  const locationName = `${locName}, ${districtName}, ${cityName}, ${countryName}, ${blockName}, ${floorName}`
  const buttonDisabled = reservationCount === capacity
  const priceVal = !!price ? priceStr : t('most-used-words.price-free')

  const openSearchModal = () => openModal(lesson)

  /* Favorite Gym Lesson */
  // const [favorite, setFavorite] = useState(IsFavorite)
  // const handleAddFavorite = () => {
  //   GymService.addGymGroupLessonFavorite(Id).then((r) => setFavorite(true))
  // }
  // const handleRemoveFavorite = () => {
  //   GymService.removeGymGroupLessonFavorite(Id).then((r) => setFavorite(false))
  // }

  return (
    <StyledCard>
      <CardHeaderOverlay>
        <FavoriteContainer>
          {/* <FavoriteIconButton onSave={handleAddFavorite} onRemove={handleRemoveFavorite} isFavorite={favorite} /> */}
        </FavoriteContainer>
      </CardHeaderOverlay>

      <div className="d-flex flex-column align-items-center flex-grow-1 px-3">
        <div className="d-flex flex-column align-items-center flex-grow-1">
          <GymSalonName>{`${name}`}</GymSalonName>
          <SalonLocation>{locationName}</SalonLocation>
          <SalonCapacity>
            <i className="pi pi-users"></i>
            <span>{reservationAndCapacityStr}</span>
          </SalonCapacity>

          <GroupTrainerArea>
            <TrainerInfo>
              <img src={photo || avatar} alt="trainer_photo" />

              <div>
                <div className="gym-trainer-name">{fullName}</div>
                <div className="gym-trainer-info">{email}</div>
              </div>
            </TrainerInfo>

            {/* Date */}
            <LessonDate className="my-2 gap-2 d-flex align-items-center">
              <i className="pi pi-calendar"></i>
              <span>
                {lessonDateStr} | {startHourStr} - {endHourStr}
              </span>
            </LessonDate>
          </GroupTrainerArea>
        </div>

        <WorkingHours>
          <span className="wh-title">{t('most-used-words.lesson-price')}: </span>
          <span>{priceVal}</span>
        </WorkingHours>

        <ReservationButton disabled={buttonDisabled} onClick={openSearchModal}>
          {t('buttons.book-reservation')}
        </ReservationButton>
      </div>
    </StyledCard>
  )
}
